export enum TraceDetailsProperties {
  timestamp = 'Trace Time',
  message = 'Message',
  name = 'Name',
  roleInstance = 'Role Instance',
}
